if (!window.nelkoFooterAccordionReady) {
  window.nelkoFooterAccordionReady = true
  window.nelkoFooterAccordionMediaQuery = window.matchMedia('(min-width: 750px)')

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncNelkoFooterAccordions)
  } else {
    syncNelkoFooterAccordions()
  }

  document.addEventListener('shopify:section:load', syncNelkoFooterAccordions)

  if (typeof window.nelkoFooterAccordionMediaQuery.addEventListener === 'function') {
    window.nelkoFooterAccordionMediaQuery.addEventListener('change', syncNelkoFooterAccordions)
  } else {
    window.nelkoFooterAccordionMediaQuery.addListener(syncNelkoFooterAccordions)
  }
}

/**
 * 同步 footer 折叠组在移动端和非移动端的默认展开状态
 */
function syncNelkoFooterAccordions() {
  var shouldOpen = window.nelkoFooterAccordionMediaQuery.matches
  var accordions = document.querySelectorAll('[data-nelko-footer-accordion]')

  accordions.forEach((accordion) => {
    if (shouldOpen) {
      accordion.setAttribute('open', '')
      return
    }

    accordion.removeAttribute('open')
  })
}


document.querySelectorAll('[data-menu]').forEach(item => {

  item.addEventListener('click', function(e){

    e.preventDefault();
    e.stopPropagation();

    const menu = this.dataset.menu;

    if(menu === "Printers"){
      window.location.href="/collections/printers";
    }
    if(menu === "Accessories"){
      window.location.href="/collections/accessories";
    }
  });

});

/**
 * Update cart quantity badge
 */
function updateNelkoCartCount() {

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {

      const badge = document.querySelector('.nelko-cart-count');

      if (!badge) return;


      if (cart.item_count > 0) {

        badge.textContent = cart.item_count;
        badge.classList.remove('is-hidden');

      } else {

        badge.textContent = '';
        badge.classList.add('is-hidden');

      }

    });

}



/**
 * Detect Shopify ajax cart actions
 */
(function(){

  const originalFetch = window.fetch;


  window.fetch = function(){

    return originalFetch.apply(this, arguments)
      .then(response => {


        const url = response.url;


        if(
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update')
        ){

          setTimeout(function(){

            updateNelkoCartCount();

          },300);

        }


        return response;

      });

  };


})();